import { render, staticRenderFns } from "./LiveingDetails.vue?vue&type=template&id=af203832&scoped=true&"
import script from "./LiveingDetails.vue?vue&type=script&lang=js&"
export * from "./LiveingDetails.vue?vue&type=script&lang=js&"
import style0 from "./LiveingDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LiveingDetails.vue?vue&type=style&index=1&id=af203832&lang=scss&scoped=true&"
import style2 from "./LiveingDetails.vue?vue&type=style&index=2&id=af203832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af203832",
  null
  
)

export default component.exports